module.exports = __webpack_public_path__ + "media/images/home/welcome_cunsomer_img-9892edcbdc263c90f9010f440b3f1eb9.jpg";